import { ActionContext } from 'vuex';
import { StateInterface } from 'src/store';
import { LoadingStateInterface } from 'src/store/loading/state';

export function setExecutionsLoading(
  context: ActionContext<LoadingStateInterface, StateInterface>,
  loading: boolean
) {
  context.commit('SET_EXECUTIONS_LOADING', loading);
}

export function setBoardsLoading(
  context: ActionContext<LoadingStateInterface, StateInterface>,
  loading: boolean
) {
  context.commit('SET_BOARDS_LOADING', loading);
}

export function setPostingsLoading(
  context: ActionContext<LoadingStateInterface, StateInterface>,
  loading: boolean
) {
  context.commit('SET_POSTINGS_LOADING', loading);
}

export function setStatisticsLoading(
  context: ActionContext<LoadingStateInterface, StateInterface>,
  loading: boolean
) {
  context.commit('SET_STATISTICS_LOADING', loading);
}

export function setUserLoading(
  context: ActionContext<LoadingStateInterface, StateInterface>,
  loading: boolean
) {
  context.commit('SET_USERS_LOADING', loading);
}

export function setTasksLoading(
  context: ActionContext<LoadingStateInterface, StateInterface>,
  loading: boolean
) {
  context.commit('SET_TASKS_LOADING', loading);
}
